var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHangDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-425.000000, -214.000000)",
    fill: "#BFBFBF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11522369,8.11522369 C18.2688553,-2.0384079 34.7311447,-2.0384079 44.8847763,8.11522369 C55.0384079,18.2688553 55.0384079,34.7311447 44.8847763,44.8847763 C34.7311447,55.0384079 18.2688553,55.0384079 8.11522369,44.8847763 C-2.0384079,34.7311447 -2.0384079,18.2688553 8.11522369,8.11522369 Z M18.5207554,31.6042336 C21.8570443,31.5940303 21.3669728,28.2036667 21.3730951,26.201893 C24.6012353,25.1911431 28.716672,24.9561416 31.8268026,26.1699261 C31.5309244,32.0092822 32.477056,31.7283677 39.2057508,31.5409784 C42.5978146,31.475002 41.9965344,28.0849777 42.002995,25.9719942 C42.0063964,24.8598976 41.6200534,23.9158065 40.9551755,23.1393788 C36.5237943,17.5924994 19.5121174,16.5324351 12.7657398,22.5027258 C10.7585253,24.2882014 11.0867127,26.0665348 11.1339856,28.7910018 C11.128884,30.4591463 12.2930149,31.6232772 14.0169343,31.5624006 L18.5207554,31.6042336 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangDisabled);
export default __webpack_public_path__ + "static/media/hangDisabled.3695698d127688a008f17abe51d65609.svg";
export { ForwardRef as ReactComponent };